import * as React from 'react';

interface LoaderProps {
  inline: boolean;
  unwrapped: boolean;
  message: string;
  children?: React.ReactNode;
}

function Loader({ inline, unwrapped, message, children }: LoaderProps) {
  const loader = (
    <div className="loading" data-testid="loader">
      <div className="otrl circle-spinner" data-testid="circle-spinner" />
      {message && <p className="loading-message">{message}</p>}
      {children}
    </div>
  );
  return unwrapped || inline ? loader : <div className="left-col left-col--loading">{loader}</div>;
}

export default Loader;
